import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import Tooltip from "../../core/tooltip";
import Icon from "../../core/icon";
import { positions, colors, sizes, icons } from "../../../enums";
var ErrorIcon = createComponent({
  displayName: 'ErrorIcon',
  propTypes: {
    errorMessage: PropTypes.string,
    errorMessagePosition: PropTypes.oneOf(positions.ALL)
  },
  defaultProps: {
    errorMessage: '',
    errorMessagePosition: positions.TOP
  },
  render: function render(props) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      tooltip: props.errorMessage,
      color: colors.ERROR,
      position: props.errorMessagePosition
    }, /*#__PURE__*/React.createElement(Icon, {
      name: icons.WARNING,
      size: sizes.X6,
      color: colors.ERROR
    }));
  }
});
export default ErrorIcon;
//# sourceMappingURL=index.js.map